<template>
    <section class="service-options">
        <div class="service-options__container container">
            <StepBar />

            <StepLink :step="5" />

            <h3 class="title">Service Options</h3>

            <div class="service-options__desktop-columns">
                <div class="card service-options__card">
                    <div class="card__inner">
                        <AdditionalServicesOptions
                            :selected-options="selectedOptions"
                            @open-modal="setModal"
                        />
                    </div>
                </div>

                <BookingOverview />

                <p v-if="validationMessage" class="service-options__validation-error">{{ validationMessage }}</p>

                <button type="button" class="btn btn--primary btn--full-width card__button service-options__button"
                    @click.prevent="next_step">
                    <span class="find-my-car__used-btn-txt">Continue</span>
                </button>
            </div>
        </div>

        <AdditionalServicesModal
            v-if="modalOpen && !shortOnlineServiceBooking"
            :modal-open="modalOpen"
            :modal-data="modalData"
            @close-modal="closeModal"
        />
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { BookingOverview, LoadingSpinner, StepBar, StepLink } from "../index.js";
import EventObject from "../../../modules/tracking/EventObject";
import Modal from '../../../core/components/ConfiguratorModal.vue';
import AdditionalServicesOptions from "./AdditionalServicesOptions.vue";
import AdditionalServicesModal from "./AdditionalServicesModal.vue";

export default {
    components: {
        AdditionalServicesOptions,
        AdditionalServicesModal,
        BookingOverview,
        LoadingSpinner,
        StepBar,
        StepLink,
        Modal,
    },

    data() {
        return {
            validationMessage: false,
            modalOpen: false,
            modalData: null,
        };
    },

    computed: {
        ...mapState("OSB", [
            "pricingData",
            "selectedOptions",
            "motDue",
            "motExpiryKnown",
            "carNotFound",
            "brand",
            "waitingForPricing",
            "waitingForServicePlan",
            "fallbackPricing",
            "haveServicePlan",
            "shortOnlineServiceBooking",
        ]),
        ...mapState("Dealers", ["selectedDealer"]),
    },

    methods: {
    ...mapMutations("OSB", ["incrementStep"]),

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        next_step() {
            new EventObject("OSB", "Click", "Additional services, continue clicked").dispatch();

            this.incrementStep();
            this.scrollToTop();
        },

        setModal(item) {
            this.modalData = item;
            this.modalOpen = true;
        },

        closeModal() {
            this.modalOpen = false;
            this.modalData = null;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/Steps/AdditionalServices.vue